export class TemplateBatch {
    public documentType: number;
    public templates: Array<string>;
    public device: string;
}